import { render, staticRenderFns } from "./list-item-relation-to-one.vue?vue&type=template&id=569f3f1b&"
import script from "./list-item-relation-to-one.vue?vue&type=script&lang=js&"
export * from "./list-item-relation-to-one.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports